/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Table_WeeksInputs */

const id_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minggu`)
};

const ms_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minggu`)
};

const da_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uger`)
};

const de_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochen`)
};

const en_us2_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weeks`)
};

const es_es2_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const es_mx2_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const fil_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linggo`)
};

const fr_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaines`)
};

const it_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimane`)
};

const hu_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hetek`)
};

const nl_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weken`)
};

const no_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uker`)
};

const pl_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tygodnie`)
};

const pt_br2_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const pt_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const ro_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Săptămâni`)
};

const fi_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viikot`)
};

const sv_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veckor`)
};

const vi_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuần`)
};

const tr_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hafta`)
};

const cs_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Týdny`)
};

const bg_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Седмици`)
};

const ru_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недели`)
};

const uk_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тижні`)
};

const ar_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسابيع`)
};

const hi_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सप्ताह`)
};

const th_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สัปดาห์`)
};

const ja_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`週数`)
};

const zh_cn2_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`周数`)
};

const zh_hant1_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`週數`)
};

const ko_collections_table_weeks = /** @type {(inputs: Collections_Table_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주`)
};

/**
* | output |
* | --- |
* | "Weeks" |
*
* @param {Collections_Table_WeeksInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_table_weeks = /** @type {((inputs?: Collections_Table_WeeksInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Table_WeeksInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_table_weeks(inputs)
	if (locale === "ms") return ms_collections_table_weeks(inputs)
	if (locale === "da") return da_collections_table_weeks(inputs)
	if (locale === "de") return de_collections_table_weeks(inputs)
	if (locale === "en-US") return en_us2_collections_table_weeks(inputs)
	if (locale === "es-ES") return es_es2_collections_table_weeks(inputs)
	if (locale === "es-MX") return es_mx2_collections_table_weeks(inputs)
	if (locale === "fil") return fil_collections_table_weeks(inputs)
	if (locale === "fr") return fr_collections_table_weeks(inputs)
	if (locale === "it") return it_collections_table_weeks(inputs)
	if (locale === "hu") return hu_collections_table_weeks(inputs)
	if (locale === "nl") return nl_collections_table_weeks(inputs)
	if (locale === "no") return no_collections_table_weeks(inputs)
	if (locale === "pl") return pl_collections_table_weeks(inputs)
	if (locale === "pt-BR") return pt_br2_collections_table_weeks(inputs)
	if (locale === "pt") return pt_collections_table_weeks(inputs)
	if (locale === "ro") return ro_collections_table_weeks(inputs)
	if (locale === "fi") return fi_collections_table_weeks(inputs)
	if (locale === "sv") return sv_collections_table_weeks(inputs)
	if (locale === "vi") return vi_collections_table_weeks(inputs)
	if (locale === "tr") return tr_collections_table_weeks(inputs)
	if (locale === "cs") return cs_collections_table_weeks(inputs)
	if (locale === "bg") return bg_collections_table_weeks(inputs)
	if (locale === "ru") return ru_collections_table_weeks(inputs)
	if (locale === "uk") return uk_collections_table_weeks(inputs)
	if (locale === "ar") return ar_collections_table_weeks(inputs)
	if (locale === "hi") return hi_collections_table_weeks(inputs)
	if (locale === "th") return th_collections_table_weeks(inputs)
	if (locale === "ja") return ja_collections_table_weeks(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_table_weeks(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_table_weeks(inputs)
	return ko_collections_table_weeks(inputs)
});
export { collections_table_weeks as "collections.table.weeks" }